import React from 'react';

const ROLE_OPTIONS = [
    { value: 'MANAGER', label: 'Менеджер' },
    { value: 'ASSISTANT', label: 'Помощник' },
    { value: 'TEAM_LEAD', label: 'Руководитель' },
    { value: 'ACCOUNTANT', label: 'Бухгалтер' },
    { value: 'ADMIN', label: 'Администратор' }
];

export const ManagerCreateModal = ({
    open,
    loading,
    form,
    teams = [],
    isEditing = false,
    onClose,
    onFieldChange,
    onSubmit
}) => {
    if (!open) return null;

    const handleSubmit = (event) => {
        event.preventDefault();
        onSubmit(event);
    };

    const handleBackdropClick = () => {};

    return (
        <div className='manager-modal-backdrop' onClick={handleBackdropClick}>
            <div className='manager-modal' role='dialog' aria-modal='true'>
                <header className='manager-modal__header'>
                    <h2>{isEditing ? 'Редактирование' : 'Новый сотрудник'}</h2>
                    <button type='button' className='manager-modal__close' onClick={onClose} disabled={loading} aria-label='Закрыть'>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 6L6 18M6 6l12 12"/></svg>
                    </button>
                </header>

                <form onSubmit={handleSubmit} className='manager-modal__body'>
                    <div className='manager-modal__grid'>
                        <div className='manager-modal__field'>
                            <label>Email *</label>
                            <input type='email' required value={form.email} onChange={e => onFieldChange('email', e.target.value)} disabled={loading} placeholder='user@example.com' autoFocus />
                        </div>
                        <div className='manager-modal__field'>
                            <label>Имя</label>
                            <input value={form.name} onChange={e => onFieldChange('name', e.target.value)} disabled={loading} placeholder='Имя сотрудника' />
                        </div>
                    </div>

                    <div className='manager-modal__field'>
                        <label>{isEditing ? 'Новый пароль' : 'Пароль *'}</label>
                        <input type='password' required={!isEditing} value={form.password} onChange={e => onFieldChange('password', e.target.value)} disabled={loading} placeholder={isEditing ? 'Оставьте пустым, чтобы не менять' : 'Минимум 6 символов'} />
                    </div>

                    <div className='manager-modal__grid'>
                        <div className='manager-modal__field'>
                            <label>Роль</label>
                            <select value={form.role || 'MANAGER'} onChange={e => onFieldChange('role', e.target.value)} disabled={loading}>
                                {ROLE_OPTIONS.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                            </select>
                            {form.role === 'ACCOUNTANT' && (
                                <small className='manager-modal__hint' style={{ display: 'block', marginTop: 4, fontSize: 12, color: 'var(--neutral-70)' }}>
                                    Бухгалтер видит все инвойсы и договоры компании, без привязки к команде.
                                </small>
                            )}
                            {form.role === 'ASSISTANT' && (
                                <small className='manager-modal__hint' style={{ display: 'block', marginTop: 4, fontSize: 12, color: 'var(--neutral-70)' }}>
                                    Помощник работает как менеджер, но видит лидов всей своей команды. Укажите команду.
                                </small>
                            )}
                        </div>
                        <div className='manager-modal__field'>
                            <label>Команда</label>
                            <select value={form.teamId || ''} onChange={e => onFieldChange('teamId', e.target.value || null)} disabled={loading}>
                                <option value=''>Без команды</option>
                                {teams.map(team => (
                                    <option key={team.id} value={team.id}>{team.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {isEditing && (
                        <label className='manager-modal__toggle'>
                            <input type='checkbox' checked={form.isActive !== false} onChange={e => onFieldChange('isActive', e.target.checked)} disabled={loading} />
                            <span>{form.isActive !== false ? 'Активен' : 'Заблокирован'}</span>
                        </label>
                    )}

                    <footer className='manager-modal__footer'>
                        <button type='button' className='ghost-button' onClick={onClose} disabled={loading}>Отмена</button>
                        <button type='submit' className='primary-button' disabled={loading || !form.email}>
                            {loading ? 'Сохранение...' : (isEditing ? 'Сохранить' : 'Создать')}
                        </button>
                    </footer>
                </form>
            </div>
        </div>
    );
};
